import { BreedVm, CountryVm } from '../api';
import { Place } from '../shared/models/model/concretes/shared/place.model';

export type DeclarationState = {
  email: string;
  addressAutocomplete: Place | null;
  address: string | null;
  postalCode: string | null;
  city: string | null;
  country: CountryVm | null;
  effect_date: string | Date | null;
};

export const initialDeclarationState: DeclarationState = {
  email: '',
  addressAutocomplete: null,
  address: null,
  postalCode: null,
  city: null,
  country: null,
  effect_date: null
};
